import dayjs from 'dayjs'

export function setSessionId(sessionId) {
  sessionStorage.setItem('sessionId', `session-${sessionId}`)
}

export function setAccessTokenExpiry({ accessTokenExpiry }) {
  localStorage.setItem('accessTokenExpiry', accessTokenExpiry)
  // Store readable format in local timezone
  localStorage.setItem(
    'accessTokenExpiryReadable',
    dayjs(accessTokenExpiry).format('YYYY-MM-DD HH:mm:ss'),
  )
}

export function getAccessTokenExpiry() {
  const expiryTimeMs = localStorage.getItem('accessTokenExpiry')
  return expiryTimeMs ? parseInt(expiryTimeMs) : null
}

export function getAccessTokenExpiryReadable() {
  return localStorage.getItem('accessTokenExpiryReadable')
}

export function isTokenExpired() {
  const expiryTimeMs = getAccessTokenExpiry()
  if (!expiryTimeMs) return true
  return dayjs().isAfter(dayjs(expiryTimeMs))
}

export function getTimeUntilExpiry() {
  const expiryTimeMs = getAccessTokenExpiry()
  if (!expiryTimeMs) return null

  const now = dayjs()
  const expiry = dayjs(expiryTimeMs)

  if (now.isAfter(expiry)) return null

  const diffMs = expiry.diff(now)
  const hours = Math.floor(diffMs / (1000 * 60 * 60))
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))

  return { hours, minutes, totalMs: diffMs }
}

export function getSessionId() {
  return sessionStorage.getItem('sessionId')
}

export function setSessionCreationTime(time) {
  sessionStorage.setItem('sessionCreationTime', time)
}

export function getSessionCreationTime() {
  return sessionStorage.getItem('sessionCreationTime')
}

export function getAuthToken() {
  return localStorage.getItem('token')
}

export function getGeoLocation() {
  const geoLocation = localStorage.getItem('geoLocation')
  try {
    return JSON.parse(geoLocation)
  } catch (error) {
    return null
  }
}

export function getAppInstallationId() {
  return localStorage.getItem('appInstallationId')
}

export function getIpAddressFromLocalStorage() {
  return localStorage.getItem('ipAddress')
}

export function getAumhumScreenId() {
  return localStorage.getItem('AUMHUM_SCREEN_ID')
}

export function getSelectedCameraInLocalStorage() {
  return localStorage.getItem('selectedCamera')
}

export function setSelectedCameraInLocalStorage(camera) {
  localStorage.setItem('selectedCamera', camera)
}

export function getSelectedMicrophoneInLocalStorage() {
  return localStorage.getItem('selectedMicrophone')
}

export function setSelectedMicrophoneInLocalStorage(microphone) {
  localStorage.setItem('selectedMicrophone', microphone)
}

export function getSelectedSpeakerInLocalStorage() {
  return localStorage.getItem('selectedSpeaker')
}

export function setSelectedSpeakerInLocalStorage(speaker) {
  localStorage.setItem('selectedSpeaker', speaker)
}
